function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "hourglass"
}, /*#__PURE__*/React.createElement("path", {
  d: "m18 20v-3c0-2.086-1.071-3.925-2.69-5 1.619-1.075 2.69-2.914 2.69-5v-3c.553 0 1-.447 1-1s-.447-1-1-1h-12c-.553 0-1 .447-1 1s.447 1 1 1v3c0 2.086 1.071 3.925 2.69 5-1.619 1.075-2.69 2.914-2.69 5v3c-.553 0-1 .447-1 1s.447 1 1 1h12c.553 0 1-.447 1-1s-.447-1-1-1zm-2-16v2h-8v-2zm-7.858 4h7.717c-.447 1.721-2 3-3.858 3s-3.412-1.279-3.859-3zm7.716 8h-7.716c.447-1.721 2-3 3.858-3s3.411 1.279 3.858 3zm-7.858 4v-2h8v2z"
}));

var Svg054Hourglass = function Svg054Hourglass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg054Hourglass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/054-hourglass.157e3a65.svg";
export { ForwardRef as ReactComponent };